import React from "react";

const ProfileCard = ({ name, bio }) => {
  return (
    <div className="profile-card">
      <div className="logo-container">
        <img 
          src="/img/logo.png" 
          alt={`Logo ${name}`} 
          className="logo-img"
        />
      </div>
      <h1>{name}</h1>
      <p>{bio}</p>
    </div>
  );
};

export default ProfileCard;